<nz-spin [nzSpinning]="loading">
  <nz-row>
    <form nz-form [formGroup]="form" (ngSubmit)="submitForm()" >
      <nz-form-item>
        <nz-form-label [nzSm]="12" [nzXs]="24" nzFor="name" nzRequired>
          <span>Name</span>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" nzErrorTip="Bitte Namen eingeben!">
          <input nz-input id="name" formControlName="name" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="12" [nzXs]="24" nzFor="shortCode" nzRequired>
          <span>Kürzel</span>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" nzErrorTip="Bitte Kürzel eingeben!">
          <input nz-input id="shortCode" formControlName="shortCode" maxlength="32" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="12" [nzXs]="24" nzFor="address" nzRequired>
          <span>Adresse</span>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" nzErrorTip="Bitte Adresse eingeben!">
          <input nz-input id="address" formControlName="address" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="flour-id-item">
        <nz-form-label [nzSm]="24" [nzXs]="24">
          <span>Flour-Store-ID</span>
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" nzExtra="Flour-Filiale für die Verkaufszahlen.">
          <div class="flour-store-ids" formArrayName="flourStoreIds">
            @for (storeId of flourStoreIds.controls; track $index) {
              <div class="flour-store-ids__row">
                <input nz-input [formControlName]="$index" [attr.aria-label]="'Flour-Store-ID ' + ($index + 1)" />
                <button
                  nz-button
                  nzType="text"
                  type="button"
                  aria-label="Store-ID entfernen"
                  (click)="removeFlourStoreId($index)">
                  <span nz-icon nzType="minus-circle" nzTheme="outline"></span>
                </button>
              </div>
            }
            <button nz-button nzType="dashed" type="button" (click)="addFlourStoreId()">
              <span nz-icon nzType="plus" nzTheme="outline"></span>
              Store-ID hinzufügen
            </button>
          </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="flour-id-item">
        <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="flourStoreKey">
          <span>Flour-Stock-ID</span>
        </nz-form-label>
        <nz-form-control
          [nzSm]="24"
          [nzXs]="24"
          nzExtra="Flour-Bestand für Warentransfer und Lagerbestand.">
          <input nz-input id="flourStoreKey" formControlName="flourStoreKey" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="12" [nzXs]="12" nzFor="isFlourStore">
          <span>Flour-Lager</span>
        </nz-form-label>
        <nz-form-control
          [nzSm]="12"
          [nzXs]="12"
          nzExtra="Erscheint unter Lagerhäuser als Warentransfer.">
          <label class="verify-checkbox" nz-checkbox formControlName="isFlourStore" id="isFlourStore"></label>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="12" [nzXs]="12" nzFor="isActive">
          <span>Aktiv</span>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="12">
          <label class="verify-checkbox" nz-checkbox formControlName="isActive" id="isActive"></label>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="12" [nzXs]="12" nzFor="isMainStore">
          <span>Haupt-Lagerhaus</span>
        </nz-form-label>
        <nz-form-control
          [nzSm]="12"
          [nzXs]="12"
          [nzExtra]="mainStoreHint">
          <label class="verify-checkbox" nz-checkbox formControlName="isMainStore" id="isMainStore"></label>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="12" [nzXs]="12" nzFor="isBbmStore">
          <span>BBM-Lager</span>
        </nz-form-label>
        <nz-form-control
          [nzSm]="12"
          [nzXs]="12"
          [nzExtra]="isAdmin ? null : 'Nur Administratoren dürfen die BBM-Berechnung ändern.'">
          <label class="verify-checkbox" nz-checkbox formControlName="isBbmStore" id="isBbmStore"></label>
        </nz-form-control>
      </nz-form-item>
    </form>
  </nz-row>
</nz-spin>
